import { END_POINTS } from '../end-points'
import fetch from '../fetch-with-authorization'

export const getExternalBankAccounts = async () =>
  fetch({
    path: END_POINTS.PAYMENT.BANK_ACCOUNTS,
  })

export const getRecurringPayment = async () =>
  fetch({
    path: END_POINTS.PAYMENT.RECURRING_PAYMENT,
  })

export const getRecurringPaymentV2 = async () =>
  fetch({
    path: END_POINTS.PAYMENT.RECURRING_PAYMENT_V2,
  })

export const allPayments = async (page = 1, limit = 10, filterType) =>
  fetch({
    path: END_POINTS.PAYMENT.PAYMENT_HISTORY + `?page=${page}&limit=${limit}&filterType=${filterType}`,
  })

export const hasScheduledOneTimePayment = async () =>
  fetch({
    path: END_POINTS.PAYMENT.HAS_ONE_TIME_PAYMENTS,
  })

export const removeRecurringPayment = async () =>
  fetch({
    path: END_POINTS.PAYMENT.RECURRING_PAYMENT,
    method: 'DELETE',
  })

export const cancelACHRePayment = async ({ achRepaymentId }) =>
  fetch({
    path: END_POINTS.PAYMENT.CANCEL_ACH_REPAYMENT,
    method: 'POST',
    body: JSON.stringify({ achRepaymentId }),
  })

export const removeRecurringPaymentV2 = async () =>
  fetch({
    path: END_POINTS.PAYMENT.RECURRING_PAYMENT_V2,
    method: 'DELETE',
  })

export const scheduleOneTimePayment = async ({
  financialAccountId,
  amountString,
  amountType,
  transferDate,
  accountSummaryData,
  consentedAt,
}) =>
  fetch({
    path: END_POINTS.PAYMENT.SCHEDULE_PAYMENT,
    method: 'POST',
    body: JSON.stringify({
      financialAccountId,
      amountString,
      amountType,
      transferDate,
      accountSummaryData,
      consentedAt,
    }),
  })

export const scheduleRecurringPayment = async ({ externalBankAccountId, amount, strategy, transferDayOfMonth }) =>
  fetch({
    path: END_POINTS.PAYMENT.SCHEDULE_RECURRING_PAYMENT,
    method: 'POST',
    body: JSON.stringify({ externalBankAccountId, amount, strategy, transferDayOfMonth }),
  })

export const scheduleRecurringPaymentV2 = async ({
  financialAccountId,
  amountType,
  fixedAmountString,
  accountSummaryData,
  consentedAt,
}) =>
  fetch({
    path: END_POINTS.PAYMENT.SCHEDULE_RECURRING_PAYMENT_V2,
    method: 'POST',
    body: JSON.stringify({ financialAccountId, amountType, fixedAmountString, accountSummaryData, consentedAt }),
  })

export const updateDefaultPaymentMethod = async ({ externalBankAccountId }) =>
  fetch({
    path: END_POINTS.PAYMENT.PAYMENT_METHODS + `/${externalBankAccountId}`,
    method: 'PUT',
  })

export const updateRewardEligibleStatus = async ({ financialAccountId, status }) =>
  fetch({
    path: END_POINTS.PAYMENT.UPDATE_REWARD_ELIGIBLE_STATUS,
    method: 'PUT',
    body: JSON.stringify({ financialAccountId, status }),
  })

export const removePaymentMethod = async ({ externalBankAccountId }) =>
  fetch({
    path: END_POINTS.PAYMENT.PAYMENT_METHODS + `/${externalBankAccountId}`,
    method: 'DELETE',
  })
